import { MasterFranchiseDocument } from './../../_models/mfa/MasterFranchiseDocument';
import { AddMasterFranchiseDocument } from './../../_models/mfa/AddMasterFranchiseDocument';

import { EnviromentService } from './../enviroment.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { PaginatedResult } from 'app/_models/Pagination';
import { map } from 'rxjs/operators';

@Injectable()
export class MasterFranchiseDocumentService {
    baseUrl = '';

    constructor(private http: HttpClient, private enviromentService: EnviromentService) {
        this.baseUrl = enviromentService.getConfig().apiMfa;
     }

    add(add: AddMasterFranchiseDocument): Observable<number> {
        return this.http.post<number>(this.baseUrl + 'MasterFranchiseDocuments', add);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.baseUrl + 'MasterFranchiseDocuments/' + id);
    }

    update(update: MasterFranchiseDocument): Observable<number> {
        return this.http.put<number>(this.baseUrl + 'MasterFranchiseDocuments/' + update.id, update);
    }

    get(id: number): Observable<MasterFranchiseDocument> {
        return this.http.get<MasterFranchiseDocument>(this.baseUrl + 'MasterFranchiseDocuments/' + id);
    }

    getMasterFranchiseDocuments(page?, itemsPerPage?, MasterFranchiseDocumentParams?): Observable<PaginatedResult<MasterFranchiseDocument[]>> {
        const paginatedResult: PaginatedResult<MasterFranchiseDocument[]> = new PaginatedResult<MasterFranchiseDocument[]>();
    
        let params = new HttpParams();
    
        if (page != null && itemsPerPage != null) {
          params = params.append('pageNumber', page);
          params = params.append('pageSize', itemsPerPage);
        }
    
    
        return this.http.get<MasterFranchiseDocument[]>(this.baseUrl + 'MasterFranchiseDocuments', { observe: 'response', params})
          .pipe(
            map(response => {
              paginatedResult.result = response.body;
              if (response.headers.get('Pagination') != null) {
                paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
              }
              return paginatedResult;
            })
          );
      }


    getByMfaId(id: number): Observable<MasterFranchiseDocument[]> {
        return this.http.get<MasterFranchiseDocument[]>(this.baseUrl + 'MasterFranchiseAgreements/' + id + '/MasterFranchiseDocuments/');
    }

}